












import { Component, Vue } from 'vue-property-decorator';
import InjuryReportForm from '@/components/forms/InjuryReportForm.vue';

@Component({
    components: {
        InjuryReportForm
    }
})
export default class InjuryReportAdd extends Vue {
}
